import React from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import NumberField from '../../app-main/components/reduxForms/fields/NumberField/NumberField';
import { ATTENDEE_PRICING_FORM } from './constants';
import Button from '../../elements-buttons/Button';
import { get } from 'lodash';
import validateAttendeePriceForm from './validate/validateAttendeePriceForm';
import { onChangeNumberGuests } from './change/onChangeAttendeeForm';
import onSubmitAttendeePriceForm from './submit/onSubmitAttendeePriceForm';
import AttendeeFields from './AttendeeFields';
import { FormattedMessage } from 'react-intl';

const AttendeePricingForm = ({
  handleSubmit = null,
  dispatch,
  handleCancel,
  attendeeTiers,
  currency,
  error
}) => {
  const parseValue = (value) => { return value ? parseInt(value, 10) : null; };
  return (
    <form className="fandb-panel panel-body border margin-md-top margin-lg-bottom container-fluid" onSubmit={handleSubmit} >
      <h4><FormattedMessage id="hosting.attending_pricing_form.heading" defaultMessage="Attendee pricing" /></h4>
      <div className="row margin-xl-bottom">
        <div className="col-sm-4">
          <label htmlFor="AttendeePricingNameInput"><FormattedMessage id="hosting.attending_pricing_form.maximum_attendees_label" defaultMessage="Maximum Attendees" /></label>
          <Field
            parse={parseValue}
            id="AttendeeAttendeeNumberInput"
            className="AttendeeAttendeeNumberInput full-length-input-sm"
            component={NumberField}
            name="number_guests"
            showErrorOnChange
            onBlur={(e, value) => onChangeNumberGuests(e, value, attendeeTiers, dispatch)}
          />
        </div>
      </div>
      <div>
        <div style={{ marginBottom: '24px' }}>
          <div className="flex">
            <div className="flex-basis-50">
              <label htmlFor="attendeeMin"><FormattedMessage id="hosting.attending_pricing_form.attendees_label" defaultMessage="Attendees" /></label>
            </div>
            <div className="flex-basis-50 text-right">
              <label htmlFor="attendeeValue"><FormattedMessage id="hosting.attending_pricing_form.additional_charge_label" defaultMessage="Additional charge/ hr" /></label>
            </div>
            <div className="flex-basis-15 text-right" />
          </div>
          <hr className="margin-md-top margin-lg-bottom" />
          <FieldArray
            name="tiers"
            component={AttendeeFields}
            currency={currency}
            dispatch={dispatch}
          />
        </div>
      </div>
      <div className="text-danger text-small">{error}</div>
      <div className="clearfix" />
      <hr />
      <div className="flex end">
        <div className="flex-basis-15 margin-md-right">
          <Button category="default" onClick={handleCancel} type="button"><FormattedMessage id="hosting.attending_pricing_form.button_text_cancel" defaultMessage="Cancel" /></Button>
        </div>
        <div className="flex-basis-15">
          <Button category="primary" />
        </div>
      </div>
    </form>
  );
};

AttendeePricingForm.propTypes = {
  handleSubmit: PropTypes.func,
  dispatch: PropTypes.func,
  handleCancel: PropTypes.func,
  currency: PropTypes.string,
  error: PropTypes.string,
  attendeeTiers: PropTypes.array.isRequired
};

const config = {
  form: ATTENDEE_PRICING_FORM,
  enableReinitialize: true,
  validate: validateAttendeePriceForm,
  onSubmit: onSubmitAttendeePriceForm
};

const selector = formValueSelector(ATTENDEE_PRICING_FORM);
const mapStateToProps = (state) => {
  return {
    listing: get(state, 'listing.data'),
    accessToken: get(state, 'auth.accessToken'),
    attendeeTiers: selector(state, 'tiers')
  };
};

export default connect(mapStateToProps)(reduxForm(config)(AttendeePricingForm));
